<div class="list-group-item requiredAction" *hideKey="'Seo-Dashboard-RequiredAction-PageOptimizationApproval'">
  <div class="d-flex flex-wrap mb-2">
    <div class="mb-1 text-danger custom-required-actions-item-title" style="min-width: 100%">
      <i class="fa fa-exclamation-circle fa-2x text-danger float-start pe-2"></i>{{ 'ra_page_optimization' | translate }}
    </div>
    <div class="text-muted ms-4 mb-2" style='min-width: 38%'>
      <small>
        <span class="customer-required-actions-text font-italic">
          {{ 'ra_page_optimization_desc' | translate: { date: requiredAction.date | date:'shortDate'} }}
        </span>
      </small>
    </div>
    @if (requiredAction.hyperlink) {
    <div class="ms-auto" style="min-width: 38%" *hideKey="'Seo-Dashboard-RequiredAction-PageOptimizationApproval-Button'">
      <a href="{{requiredAction.hyperlink}}" target="_blank" class="btn btn-primary btn-sm align-self-start custom-required-actions-item-button w-100">
        {{'preview_content' | translate }}
      </a>
    </div>
    }
  </div>
</div>
